import { render } from "./MultipleImages.vue?vue&type=template&id=61daa995"
import script from "./MultipleImages.vue?vue&type=script&lang=js"
export * from "./MultipleImages.vue?vue&type=script&lang=js"

import exportComponent from "/home/rosenfeldt/projects/rosenfeldt/public_html/webshop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__